import React from "react";
import {
  SubTitleTab,
  TitleTab,
} from "../../../../../../component/page-components";
import { DatePicker, Input } from "antd";
import Dragger from "../../../../../../component/dragger/Dragger";
import DropdownSearchTemperatureCategory from "../../../../../../component/dropdown-search/dds-temperature-category";
import DropdownSearchSkillset from "../../../../../../component/dropdown-search/dds-skillset";
import DropdownListLicenseType from "../../../../../../component/dropdown-list/ddl-license-type";

const FleetDetailOutsource = ({
  form,
  setSelectedFileList2,
  selectedFileList2,
  err,
  error,
  tempCategory,
  setTempCategory,
  depotId,
  skillSet,
  setSkillSet,
  handleFormInput,
  FormInput,
  licenseType,
  setLicenseType,
  handleFormInputDate,
  FormInputDate,
  FormError,
}) => {
  return (
    <div>
      <div className="columns">
        <TitleTab title="Fleet Detail" />

        <div className="container-field">
          <SubTitleTab title="Driver License Photo (Optional)" />
          <div>
            <Dragger
              selectedFileList={selectedFileList2}
              setSelectedFileList={setSelectedFileList2}
            />
          </div>
        </div>

        <div className="container-field">
          <SubTitleTab title="License Type" />
          <DropdownListLicenseType
            placeholder="Select License Type"
            valueDDS={licenseType}
            setValueDDS={setLicenseType}
          />
          <div className="text-red-100">{err ? err : error?.license_type}</div>
        </div>

        <div className="container-field">
          <SubTitleTab title="License ID" />
          <Input
            placeholder="Type License ID"
            size="large"
            disabled
            value={form?.license_id}
          />
        </div>

        <div className="container-field">
          <SubTitleTab title="License Number" />
          <Input
            size="large"
            placeholder="Type License Number"
            onChange={(evt) => {
              handleFormInput(evt.target.value, "driving_license_no");
            }}
            value={FormInput?.driving_license_no}
            maxLength={30}
            status={error?.driving_license_no ? "error" : null}
          />
          <div className="text-red-100">
            {err ? err : error?.driving_license_no}
          </div>
        </div>

        <div className="container-field">
          <SubTitleTab title="Validity Period of Driving License" />
          <DatePicker
            style={{ width: "100%" }}
            size="large"
            format="DD MMMM YYYY"
            placeholder="Select Validity Period of Driving License"
            onChange={(evt) => {
              handleFormInputDate(evt, "license_validity");
            }}
            allowClear={true}
            value={
              FormInputDate?.license_validity
                ? FormInputDate?.license_validity
                : undefined
            }
            status={error?.license_validity ? "error" : null}
          />
          <div className="text-red-100">
            {err ? err : error?.license_validity}
          </div>
        </div>

        <div className='container-field'>
          <SubTitleTab title="Licence Plate Expired" />
          <DatePicker
            placeholder={"Select Licence Plate Expired"}
            style={{ width: "100%" }}
            format={`DD MMMM YYYY`}
            onChange={(evt) => handleFormInputDate(evt, "vehicle_no_exp_date")}
            allowClear={true}
            size="large"
            value={
              FormInputDate?.vehicle_no_exp_date
                ? FormInputDate?.vehicle_no_exp_date
                : undefined
            }
            status={error?.vehicle_no_exp_date ? "error" : null}
          />
          <div className="text-red-100">
            {err ? err : error?.vehicle_no_exp_date}
          </div>
        </div>

        <div className="container-field">
          <SubTitleTab title="Vehicle Type (Optional)" />
          <Input
            size="large"
            placeholder="Type Vehicle Type"
            onChange={(evt) => {
              handleFormInput(evt.target.value, "vehicle_type");
            }}
            value={FormInput?.vehicle_type}
            maxLength={20}
            status={error?.vehicle_type ? "error" : null}
          />
          <div className="text-red-100">{err ? err : error?.vehicle_type}</div>
        </div>

        <div className="container-field">
          <SubTitleTab title="Vehicle Model (Optional)" />
          <Input
            size="large"
            placeholder="Type Vehicle Model"
            onChange={(evt) => {
              handleFormInput(evt.target.value, "model");
            }}
            value={FormInput?.model}
            maxLength={20}
            status={error?.model ? "error" : null}
          />
          <div className="text-red-100">{err ? err : error?.model}</div>
        </div>

        <div className="container-field">
          <SubTitleTab title="Vehicle No" />
          <Input
            size="large"
            placeholder="Type Vehicle No"
            onChange={(evt) => {
              handleFormInput(evt.target.value, "vehicle_no");
            }}
            value={FormInput?.vehicle_no}
            maxLength={20}
            status={error?.vehicle_no ? "error" : null}
          />
          <div className="text-red-100">{err ? err : error?.vehicle_no}</div>
        </div>

        <div className="container-field">
          <SubTitleTab title="Temperature Category" />
          <DropdownSearchTemperatureCategory
            placeholder="Select Temperature Category"
            setValueDDS={setTempCategory}
            valueDDS={tempCategory}
          />
          <div className="text-red-100">
            {err ? err : error?.temperature_category_id}
          </div>
        </div>

        <div className="container-field">

          <SubTitleTab title="Skill Set" />
          <DropdownSearchSkillset
            placeholder="Select Skillset"
            depotId={depotId}
            valueDDS={skillSet}
            setValueDDS={setSkillSet}
          />
          <div className="text-red-100">{err ? err : error?.skill_set}</div>
        </div>
         
      <div className="container-field">
        <SubTitleTab title="Total Range Distance" />
        <Input
          addonAfter="Km"
          size="large"
          value={FormInput?.total_range_distance}
          disabled
        />
      </div>
      </div>
    </div>
  );
};

export default FleetDetailOutsource;
